export const ENVIRONMENT = {
  STAGING: 'vistaprint-staging',
  PRODUCTION: 'vistaprint-production',
  UNKNOWN: '',
};
